/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Wizard from 'shared/ui/components/Wizard.vue';
import TemplateForm from './create-template/TemplateForm.vue';

// Utils
import { get, isEmpty } from 'lodash';

/**
 * This component is used to create a new template.
 *
 * It uses a `Wizard` to guide the user through the creation process.
 *
 * @category ui.components.wizards
 * @exports CreateTemplate
 */
const __vue_script__ = {
    name: 'CreateTemplate',

    components: { Wizard, TemplateForm },

    props: {
        eventId: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            error: null,
            form: {},
            jobProgressUrl: null,
            jobProgressPath: this.$const.CREATE_WORKSPACE_QUEUE_JOB_RESULT_PATH,
            progress: 0,
            wizardCompleted: false,
            steps: [{
                title: 'wizards.create_template.main_title',
                component: TemplateForm,
                nextLabel: 'wizards.create_template.action',
                props: { eventId: this.eventId }
            }]
        };
    },

    computed: {
        /**
         * @returns {Boolean} whether to show the wizard or not
         */
        showWizard() {
            return !this.wizardCompleted;
        }
    },

    methods: {
        /**
         * Submits data to create the workspace with gathered information.
         *
         * @param {Object} data the wizard collected data
         */
        async submitForm(data) {
            try {
                if (isEmpty(data)) {
                    console.warn('[CreateTemplate] Can\'t create a template with no data!');
                    this.setError('wizard.errors.no_data');
                    return;
                }

                if (data.parentType.value === 'workspace') {
                    // "parents" workspace contains only minimal data, in order to
                    // clone the event we need more data.
                    data.parent = await this.$services.event.getEvent(data.parent._id);
                }

                console.info('[CreateTemplate] Wizard\'s collected data:', data);
                this.wizardCompleted = true;

                const { jobId, node, error } = await this.registerJob(data);

                if (error || !jobId || !node) {
                    // Something went wrong, stop here.
                    console.error('[CreateTemplate] Can\'t register the job.', error);
                    this.setError(error || 'wizards.create_template.errors.job_registration');
                    return;
                }

                this.jobProgressUrl = this.$utils.url.getBackstageURL(node, this.jobProgressPath);

                const minutesToTimeout = 15, interval = 2500;
                const { eid } = await this.$services.jobs.waitFor({
                    jobId,
                    resultPath: this.jobProgressUrl,
                    statusPath: this.jobProgressUrl,
                    updateUIProgress: this.updateProgress,
                    interval,
                    minutesToTimeout
                });
                const eventUrl = this.$services.event.getEventUrl({
                    _id: eid,
                    node
                });

                await this.uploadImages(data.app_icon, data.screenshots, eid, node);

                this.reset();
                this.$router.redirect(eventUrl);

            } catch (error) {
                console.error('[CreateTemplate] Could not create template', error);
                this.$services.crashReporting.captureException(error);
                this.setError((error || {}).error || 'wizards.create_template.errors.job_creation_failed');
            }
        },

        /**
         * Stores the create workspace job on the backend job runner, if something goes wrong
         * during this process shows an error and exits.
         *
         * @param {Object} data the payload needed to create the workspace
         *
         * @returns {Promise<Object>} the job registration response
         */
        async registerJob(data) {
            const response = await this.$services.template.createTemplate(data);
            const { error, message } = response;

            if (!error) {
                return response;
            }

            const msg = get(message, 'error') || error;

            return { error: msg };
        },

        /**
         * Uploads app icon and screenshots
         *
         * @param {File[]} appIcon the app icon to upload to the template
         * @param {File[]} screenshots the screenshots to upload to the template
         * @param {String} eventId the Event ID to upload the images to
         * @param {String} node the node to use for the given event
         */
        async uploadImages(appIcon, screenshots, eventId, node) {
            try {

                // We first upload the screenshots and then the app icon
                // The app icon is uploaded using appscript that creates a queue job and
                // switching the order will end up in a document conflict.
                if (!isEmpty(screenshots)) {
                    await this.$services.template.uploadImages(screenshots, eventId);
                    console.info('[CreateTemplate] Screenshots upload completed');
                }

                if (!isEmpty(appIcon)) {
                    await this.$services.event.uploadAppIcon(appIcon[0], eventId, node);
                    console.info('[CreateTemplate] App icon upload completed');
                }

            } catch (error) {
                console.error('[CreateTemplate] Could not upload image(s)');
                this.$services.crashReporting.captureException(error);
            }
        },

        /**
         * Updates the creation process progress.
         *
         * @param {Number} progress the current progress
         */
        updateProgress(progress) {
            this.progress = progress;
        },

        /**
         * Sets the error and displays it to the user.
         *
         * @param {String} error the eventual occurred error.
         */
        async setError(error) {
            this.error = error;
        },

        /**
         * Resets the component to its initial state and closes the modal.
         */
        reset() {
            this.error = null;
            this.form = {};
            this.jobProgressUrl = null;
            this.jobProgressPath = this.$const.CREATE_WORKSPACE_QUEUE_JOB_RESULT_PATH;
            this.progress = 0;
            this.wizardCompleted = false;

            this.$emit('close');
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-template"},[(_vm.showWizard)?_c('wizard',{attrs:{"initial-data":_vm.form,"steps":_vm.steps},on:{"wizard:completed":_vm.submitForm}},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.reset()}}}),_c('h1',[_vm._v(_vm._s(_vm.$t('wizards.create_template.main_title')))])]):_vm._e(),(!_vm.showWizard && !_vm.error)?_c('div',{staticClass:"creation modal-wrapper"},[_c('div',{staticClass:"modal-header"},[_c('h3',[_vm._v(_vm._s(_vm.$t('wizards.create_template.creation_title')))])]),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(_vm.$t('wizards.create_template.creation_progress')))]),_c('progress-bar',{attrs:{"progress":_vm.progress}})],1)]):_vm._e(),(_vm.error)?_c('div',{staticClass:"errors modal-wrapper"},[_c('div',{staticClass:"modal-header"},[_c('h3',[_vm._v(_vm._s(_vm.$t('general.something_wrong')))])]),_c('div',{staticClass:"modal-body"},[(_vm.error.length !== 0)?_c('p',[_vm._v(_vm._s(_vm.$t('general.error_occurred'))+":")]):_vm._e(),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.error))}}),_c('p',[_vm._v(_vm._s(_vm.$t('general.try_later')))])]),_c('div',{staticClass:"modal-footer"},[_c('footer',{staticClass:"actions",attrs:{"slot":"bottom"},slot:"bottom"},[_c('button',{staticClass:"btn primary",on:{"click":function($event){return _vm.reset()}}},[_vm._v(_vm._s(_vm.$t('general.close')))])])])]):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CreateTemplate.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__